import { FunctionComponent, Children } from 'react';
import { Spinner } from 'components/elements';
import { Overlay } from 'components/overlays';
import { StyledLoadingOverlay } from './LoadingOverlay.styled';

export const LoadingOverlay: FunctionComponent = props => {
  const { children } = props;

  return (
    <Overlay>
      <Spinner />
      {Children.count(children) > 0 && <StyledLoadingOverlay>{children}</StyledLoadingOverlay>}
    </Overlay>
  );
};
